import script from "./AudioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioButton.vue?vue&type=script&setup=true&lang=js"

import "./AudioButton.vue?vue&type=style&index=0&id=230e98ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230e98ac"]])

export default __exports__